export default [
  {
    component: 'CNavTitle',
    name: 'Dashboard',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavTitle',
    name: 'Modulos',
  },
  {
    component: 'CNavGroup',
    name: 'Modulos',
    icon: 'cil-browser',
    items: [
      {
        component: 'CNavItem',
        name: 'Lista de Ganhadores',
        icon: 'cil-browser',
        to: '/modulo3',
      },
      {
        component: 'CNavItem',
        name: 'Bichão | Lista Ganhadores',
        icon: 'cil-browser',
        to: '/GanhadoresBichao',
      },
      {
        component: 'CNavItem',
        name: 'Todos | Links Ads',
        icon: 'cil-browser',
        to: '/LinksAdsNew',
      },
      {
        component: 'CNavItem',
        name: 'Monitor Campanhas WhatsApp',
        icon: 'cil-browser',
        to: '/WhatsappCampaignMonitor',
      },
      {
        component: 'CNavItem',
        name: 'Todos | Compradores de combo',
        icon: 'cil-browser',
        to: '/ComboBuyersReport',
      },
      {
        component: 'CNavItem',
        name: 'Todos | Barras',
        icon: 'cil-browser',
        to: '/newbarrar',
      },
      {
        component: 'CNavItem',
        name: 'Popups | Gerenciamento de Popups',
        icon: 'cil-browser',
        to: '/popups',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Sua Rifa',
    icon: 'cil-browser',
    to: '/rifa',
  },
  {
    component: 'CNavGroup',
    name: 'Layout',
    icon: 'cil-browser',
    items: [
      {
        component: 'CNavItem',
        name: 'Icones SideBar',
        icon: 'cil-browser',
        to: '/layput/sidebar',
      },
      {
        component: 'CNavItem',
        name: 'Cores Site',
        icon: 'cil-browser',
        to: '/layput/corsite',
      },
      {
        component: 'CNavItem',
        name: 'BtnHome',
        icon: 'cil-browser',
        to: '/layput/btnhome',
      },
    ],
  },
]
